import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {PropType} from "vue";
import {TableRouterOptions, VATableRecord} from "../extends/typing";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'TableRouter',
  props: {
  value: {
    type: String,
    required: true
  },
  options: {
    type: Object as PropType<TableRouterOptions>,
    required: true
  },
  record: {
    type: Object as PropType<VATableRecord>,
    default: () => {
      return {}
    }
  }
},
  setup(__props) {

const router = useRouter()

const props = __props

// 路由跳转点击事件
const on = () =>{
  if (!props.options.name) {
    throw new Error("前端数据未定义跳转的路由名称")
  }
  // 路由跳转携带参数，默认获取传入的参数
  let query = props.options.query || {}
  if(props.options.key){
    query[props.options.key] = props.record[props.options.dataIndex]
  }
  router.push({name: props.options.name, query: query});
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("a", {
      onClick: _withModifiers(on, ["prevent"])
    }, _toDisplayString(__props.value), 1)
  ]))
}
}

})